import React, { useEffect } from 'react';
import { Layout as AntLayout, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { getCurrentUser } from '../../../store/slices/authSlice';
import { RootState, AppDispatch } from '../../../store';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import { LayoutContainer, ContentArea, MainContent } from './Layout.styles';

const { Content } = AntLayout;

const Layout: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (isAuthenticated && !user) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, isAuthenticated, user]);

  if (isAuthenticated && !user) {
    return (
      <LayoutContainer>
        <Spin size="large" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          height: '100vh'
        }} />
      </LayoutContainer>
    );
  }

  return (
    <LayoutContainer>
      <AntLayout style={{ minHeight: '100vh' }}>
        <Sidebar />
        <AntLayout>
          <Header />
          <ContentArea>
            <MainContent>
              <Outlet />
            </MainContent>
          </ContentArea>
        </AntLayout>
      </AntLayout>
    </LayoutContainer>
  );
};

export default Layout;